import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactModal from "react-modal";
import Layout from "../../components/layout/V2/Layout";
import { useAuth } from "../../utils/Contexts/V2/AuthenticationContext";
import Button from "../../components/forms/Button";
import ProfileImage from "../../assets/images/profile.png";
import WhatsAppIcon from "../../assets/icons/logos_whatsapp.png";
import { useBusinessContext } from "../../utils/Contexts/V2/BusinessContext";
import { useAppContext } from "../../utils/Contexts/AppContext";

const logoutModalSyles = {
  content: {
    inset: "auto 0px 0px 0px",
    borderRadius: "16px 16px 0 0",
  },
  overlay: {
    backgroundColor: "#00000033",
  },
};

export default function AccountPage() {
  const { user, logout } = useAuth();
  const { clearBusinessContext } = useBusinessContext();
  const { appVendor } = useAppContext();

  const navigate = useNavigate();

  const [profileImage, setProfileImage] = useState(undefined);
  const [showShareDialogue, setShowShareDialogue] = useState(false);
  const [operation, setOperation] = useState(null);

  const showDialogueHandler = (bool, type) => {
    setShowShareDialogue(bool);
    setOperation(type);
  };

  useEffect(() => {
    if (user?.profile_photo_url) {
      setProfileImage(user.profile_photo_url);
    } else {
      setProfileImage(ProfileImage);
    }
  }, [user]);

  const [tappiWhatsappNumber, setTappiWhatsappNumber] =
    useState("+254715412061");

  useEffect(() => {
    if (appVendor === "thryve") {
      setTappiWhatsappNumber("+2348101475602");
    }
  }, [user]);

  const [logoutModalIsVisible, setLogoutModalIsVisible] = useState(false);

  const handleLogout = async () => {
    setLogoutModalIsVisible(true);
  };

  return (
    <Layout
      headerTitle="My Account"
      showDialogueHandler={showDialogueHandler}
      operation={operation}
      show={showShareDialogue}
    >
      <ReactModal
        style={logoutModalSyles}
        isOpen={logoutModalIsVisible}
        onRequestClose={() => setLogoutModalIsVisible(false)}
      >
        <div className="flex flex-col max-w-screen-xl container mx-auto">
          <div className="header text-center text-[#1A1A1A] font-semibold">
            <h3>Log Out</h3>
          </div>
          <p className="py-2 pb-4 text-[#566370] leading-5">
            Are you sure you want to leave the app?
          </p>
          <div className="space-y-4 flex flex-col">
            <Button
              onClick={async () => {
                setLogoutModalIsVisible(false);
                await logout();
                clearBusinessContext();
                navigate("/join");
              }}
            >
              <span className="tappi:text-white">Yes, Log Out</span>
            </Button>
            <Button
              variant="outline"
              onClick={() => setLogoutModalIsVisible(false)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </ReactModal>
      <div className="relative overflow-y-auto min-h-screen scroll-smooth py-20 pb-28 w-screen md:max-w-screen-lg px-2 flex flex-col items-center">
        <div className="flex flex-col items-center">
          <img
            src={profileImage}
            alt="profile"
            className="rounded-xl border border-2 border-[#E7E7E7] h-24 w-24"
          />
          <div className="mt-4 flex flex-col justify-center items-center w-full space-y-4">
            <h1 className="text-[#1A1A1A] font-semibold font-base leading-4">
              {user?.business_name}
            </h1>
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://${user?.subdomain}.tappi.ke`}
              className=" font-normal font-xs underline text-primary-50"
            >
              {`https://${user?.subdomain}.tappi.ke`}
            </a>
          </div>
        </div>
        <div className="container flex flex-col mt-6 space-y-4">
          <Button
            className="flex items-center"
            variant="outline"
            href="/account/profile"
          >
            <svg
              viewBox="0 0 448 512"
              height="1em"
              width="1em"
              className="fill-primary-50 thryve:fill-secondary-50 border border-[#C3B4DA] thryve:border-secondary-50  h-6 w-6 p-1 rounded-full mr-2"
            >
              <path
                fill="#4B1D8F"
                d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3h-91.4z"
              />
            </svg>
            <span className="text-[#1A1A1A] text-sm font-bold">My Profile</span>
          </Button>
          <Button
            className="flex items-center"
            variant="outline"
            href="/account/template"
          >
            <svg
              height="1em"
              width="1em"
              className="fill-primary-50 thryve:fill-secondary-50 border border-[#C3B4DA] thryve:border-secondary-50  h-6 w-6 p-1 rounded-full mr-2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 2a10 10 0 100 20 10 10 0 000-20zm0 0c2.21 0 4 4.477 4 10s-1.79 10-4 10-4-4.477-4-10 1.79-10 4-10zm-8 10h16"
              />
            </svg>
            <span className="text-[#1A1A1A] text-sm font-bold">
              My Website Template
            </span>
          </Button>
          <Button
            className="hidden thryve:flex items-center"
            variant="outline"
            href="/account/my-bank-details"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              className="fill-primary-50 thryve:fill-secondary-50 border border-[#C3B4DA] thryve:border-secondary-50  h-6 w-6 p-1 rounded-full mr-2"
            >
              <path
                d="M7.292 1.71192C7.71 1.39192 8.291 1.39192 8.709 1.71192L13.671 5.50492C14.303 5.98792 13.964 6.99592 13.17 6.99992H2.83C2.037 6.99592 1.697 5.98792 2.33 5.50492L7.292 1.71192ZM8 5.24992C8.19891 5.24992 8.38968 5.17091 8.53033 5.03025C8.67098 4.8896 8.75 4.69884 8.75 4.49992C8.75 4.30101 8.67098 4.11025 8.53033 3.96959C8.38968 3.82894 8.19891 3.74992 8 3.74992C7.80109 3.74992 7.61032 3.82894 7.46967 3.96959C7.32902 4.11025 7.25 4.30101 7.25 4.49992C7.25 4.69884 7.32902 4.8896 7.46967 5.03025C7.61032 5.17091 7.80109 5.24992 8 5.24992ZM3.5 7.99992V10.9999H5V7.99992H3.5ZM6 7.99992V10.9999H7.5V7.99992H6ZM8.5 7.99992V10.9999H10V7.99992H8.5ZM11 7.99992V10.9999H12.5V7.99992H11ZM2 13.2499C2 12.5599 2.56 11.9999 3.25 11.9999H12.75C13.44 11.9999 14 12.5599 14 13.2499V13.4999C14 13.6325 13.9473 13.7597 13.8536 13.8535C13.7598 13.9472 13.6326 13.9999 13.5 13.9999H2.5C2.36739 13.9999 2.24021 13.9472 2.14645 13.8535C2.05268 13.7597 2 13.6325 2 13.4999V13.2499Z"
                fill="#006187"
              />
            </svg>
            <span className="text-[#1A1A1A] text-sm font-bold">
              My Bank Details
            </span>
          </Button>
          <Button
            className="flex items-center"
            variant="outline"
            href="/account/connected-accounts"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 18 18"
              className="fill-primary-50 thryve:fill-secondary-50 border border-[#C3B4DA] thryve:border-secondary-50  h-6 w-6 p-1 rounded-full mr-2"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M17.5675 0.432816C17.5095 0.374706 17.4406 0.328606 17.3647 0.297153C17.2888 0.265701 17.2075 0.249512 17.1253 0.249512C17.0432 0.249512 16.9619 0.265701 16.886 0.297153C16.8101 0.328606 16.7412 0.374706 16.6832 0.432816L12.5894 4.52735L12.1699 4.10703C11.7005 3.63903 11.0647 3.37621 10.4019 3.37621C9.73909 3.37621 9.1033 3.63903 8.63394 4.10703L6.81285 5.92891L6.31754 5.43282C6.20026 5.31554 6.0412 5.24966 5.87535 5.24966C5.7095 5.24966 5.55044 5.31554 5.43316 5.43282C5.31588 5.55009 5.25 5.70915 5.25 5.875C5.25 6.04086 5.31588 6.19992 5.43316 6.31719L5.92925 6.8125L4.10738 8.6336C3.87517 8.86575 3.69097 9.14137 3.5653 9.44473C3.43963 9.74808 3.37494 10.0732 3.37494 10.4016C3.37494 10.7299 3.43963 11.0551 3.5653 11.3584C3.69097 11.6618 3.87517 11.9374 4.10738 12.1695L4.52769 12.5891L0.43316 16.6828C0.375091 16.7409 0.329028 16.8098 0.297602 16.8857C0.266175 16.9616 0.25 17.0429 0.25 17.125C0.25 17.2071 0.266175 17.2884 0.297602 17.3643C0.329028 17.4402 0.375091 17.5091 0.43316 17.5672C0.550435 17.6845 0.709495 17.7504 0.875348 17.7504C0.957469 17.7504 1.03879 17.7342 1.11466 17.7027C1.19053 17.6713 1.25947 17.6253 1.31754 17.5672L5.41128 13.4727L5.83082 13.893C6.30028 14.3608 6.93602 14.6235 7.59878 14.6235C8.26155 14.6235 8.89729 14.3608 9.36675 13.893L11.1878 12.0711L11.6832 12.5672C11.7412 12.6253 11.8102 12.6713 11.886 12.7027C11.9619 12.7342 12.0432 12.7504 12.1253 12.7504C12.2075 12.7504 12.2888 12.7342 12.3647 12.7027C12.4405 12.6713 12.5095 12.6253 12.5675 12.5672C12.6256 12.5091 12.6717 12.4402 12.7031 12.3643C12.7345 12.2884 12.7507 12.2071 12.7507 12.125C12.7507 12.0429 12.7345 11.9616 12.7031 11.8857C12.6717 11.8098 12.6256 11.7409 12.5675 11.6828L12.0714 11.1875L13.8933 9.36641C14.1255 9.13426 14.3097 8.85863 14.4354 8.55528C14.5611 8.25193 14.6258 7.92679 14.6258 7.59844C14.6258 7.27009 14.5611 6.94495 14.4354 6.6416C14.3097 6.33825 14.1255 6.06263 13.8933 5.83047L13.473 5.41094L17.5675 1.31719C17.6256 1.25915 17.6717 1.19021 17.7032 1.11434C17.7347 1.03847 17.7508 0.957138 17.7508 0.875003C17.7508 0.792869 17.7347 0.71154 17.7032 0.635666C17.6717 0.559792 17.6256 0.490862 17.5675 0.432816ZM13.0089 8.47969L11.1878 10.3039L7.69644 6.8125L9.51832 4.99141C9.75271 4.75717 10.0705 4.62558 10.4019 4.62558C10.7333 4.62558 11.0511 4.75717 11.2855 4.99141L13.0089 6.71016C13.125 6.82624 13.2171 6.96405 13.28 7.11572C13.3428 7.2674 13.3752 7.42997 13.3752 7.59414C13.3752 7.75832 13.3428 7.92089 13.28 8.07256C13.2171 8.22424 13.125 8.36205 13.0089 8.47813V8.47969ZM5.90738 1.69766C5.85496 1.54039 5.86716 1.36875 5.94129 1.22048C6.01543 1.0722 6.14543 0.959456 6.30269 0.907035C6.45996 0.854613 6.6316 0.866812 6.77988 0.940947C6.92815 1.01508 7.04089 1.14508 7.09332 1.30235L7.71832 3.17735C7.74427 3.25522 7.75464 3.33744 7.74882 3.41931C7.743 3.50119 7.72111 3.58112 7.6844 3.65453C7.6477 3.72795 7.59689 3.79342 7.53488 3.8472C7.47287 3.90098 7.40087 3.94202 7.323 3.96797C7.16574 4.02039 6.99409 4.0082 6.84582 3.93406C6.7724 3.89735 6.70694 3.84654 6.65316 3.78453C6.59938 3.72252 6.55834 3.65053 6.53238 3.57266L5.90738 1.69766ZM0.907379 6.30235C0.93333 6.22447 0.974367 6.15248 1.02815 6.09046C1.08193 6.02845 1.14739 5.97764 1.22081 5.94093C1.29423 5.90422 1.37416 5.88233 1.45604 5.87652C1.53791 5.8707 1.62013 5.88107 1.698 5.90703L3.573 6.53203C3.65087 6.55799 3.72287 6.59903 3.78488 6.65281C3.84689 6.70659 3.8977 6.77206 3.9344 6.84548C3.97111 6.91889 3.993 6.99882 3.99882 7.08069C4.00464 7.16257 3.99427 7.24479 3.96832 7.32266C3.94236 7.40053 3.90132 7.47252 3.84754 7.53453C3.79376 7.59654 3.72829 7.64735 3.65488 7.68406C3.58146 7.72077 3.50153 7.74266 3.41966 7.74848C3.33778 7.75429 3.25556 7.74393 3.17769 7.71797L1.30269 7.09297C1.22482 7.06702 1.15282 7.02598 1.09081 6.9722C1.0288 6.91843 0.977984 6.85296 0.941275 6.77954C0.904566 6.70612 0.882679 6.62619 0.876863 6.54431C0.871047 6.46244 0.881416 6.38022 0.907379 6.30235ZM17.0933 11.6977C17.0674 11.7755 17.0263 11.8475 16.9725 11.9095C16.9188 11.9716 16.8533 12.0224 16.7799 12.0591C16.7065 12.0958 16.6265 12.1177 16.5447 12.1235C16.4628 12.1293 16.3806 12.1189 16.3027 12.093L14.4277 11.468C14.2704 11.4155 14.1404 11.3028 14.0663 11.1545C13.9922 11.0063 13.98 10.8346 14.0324 10.6773C14.0848 10.5201 14.1975 10.3901 14.3458 10.3159C14.4941 10.2418 14.6657 10.2296 14.823 10.282L16.698 10.907C16.7759 10.933 16.8479 10.974 16.9099 11.0278C16.9719 11.0816 17.0227 11.147 17.0594 11.2205C17.0961 11.2939 17.118 11.3738 17.1238 11.4557C17.1296 11.5376 17.1193 11.6198 17.0933 11.6977ZM12.0933 16.3023C12.1457 16.4596 12.1335 16.6313 12.0594 16.7795C11.9853 16.9278 11.8553 17.0406 11.698 17.093C11.5407 17.1454 11.3691 17.1332 11.2208 17.0591C11.0725 16.9849 10.9598 16.8549 10.9074 16.6977L10.2824 14.8227C10.23 14.6654 10.2422 14.4937 10.3163 14.3455C10.3904 14.1972 10.5204 14.0845 10.6777 14.032C10.835 13.9796 11.0066 13.9918 11.1549 14.0659C11.3031 14.1401 11.4159 14.2701 11.4683 14.4273L12.0933 16.3023Z" />
            </svg>
            <span className="text-[#1A1A1A] text-sm font-bold">
              Connected Accounts
            </span>
          </Button>
          <Button
            className="flex items-center"
            variant="outline"
            href="/account/qr-code"
          >
            <svg
              viewBox="0 0 24 24"
              className="fill-primary-50 thryve:fill-secondary-50 border border-[#C3B4DA] thryve:border-secondary-50  h-6 w-6 p-1 rounded-full mr-2"
            >
              <path d="M3 11h8V3H3zm2-6h4v4H5zM3 21h8v-8H3zm2-6h4v4H5zm8-12v8h8V3zm6 6h-4V5h4zm-5.99 4h2v2h-2zm2 2h2v2h-2zm-2 2h2v2h-2zm4 0h2v2h-2zm2 2h2v2h-2zm-4 0h2v2h-2zm2-6h2v2h-2zm2 2h2v2h-2z" />
            </svg>

            <span className="text-[#1A1A1A] text-sm font-bold">QR Code</span>
          </Button>
          <Button
            className="items-center hidden tappi:flex"
            variant="outline"
            href="/account/subscription"
          >
            <svg
              viewBox="0 0 24 24"
              height="1em"
              width="1em"
              className="fill-primary-50 thryve:fill-secondary-50 border border-[#C3B4DA] thryve:border-secondary-50  h-6 w-6 p-1 rounded-full mr-2"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm4.82-4.924A7 7 0 009.032 5.658l.975 1.755A5 5 0 0117 12h-3l2.82 5.076zm-1.852 1.266l-.975-1.755A5 5 0 017 12h3L7.18 6.924a7 7 0 007.788 11.418z" />
            </svg>
            <span className="text-[#1A1A1A] text-sm font-bold">
              My Susbscriptions
            </span>
          </Button>
          {/**
          <Button
            className="flex items-center"
            variant="outline"
            href="/account/qr-code"
            disabled
          >
            <svg
              viewBox="0 0 24 24"
              className="fill-primary-50 thryve:fill-secondary-50 border border-[#C3B4DA] thryve:border-secondary-50  h-6 w-6 p-1 rounded-full mr-2"
            >
              <path d="M3 11h8V3H3zm2-6h4v4H5zM3 21h8v-8H3zm2-6h4v4H5zm8-12v8h8V3zm6 6h-4V5h4zm-5.99 4h2v2h-2zm2 2h2v2h-2zm-2 2h2v2h-2zm4 0h2v2h-2zm2 2h2v2h-2zm-4 0h2v2h-2zm2-6h2v2h-2zm2 2h2v2h-2z" />
            </svg>

            <span className="text-[#1A1A1A] text-sm font-bold">QR Code</span>
          </Button>
          <Button
            className="flex items-center"
            variant="outline"
            href="/faq"
            disabled
          >
            <svg
              viewBox="0 0 24 24"
              className="fill-primary-50 thryve:fill-secondary-50 border border-[#C3B4DA] thryve:border-secondary-50  h-6 w-6 p-1 rounded-full mr-2"
            >
              <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm1 16h-2v-2h2v2zm.976-4.885c-.196.158-.385.309-.535.459-.408.407-.44.777-.441.793v.133h-2v-.167c0-.118.029-1.177 1.026-2.174.195-.195.437-.393.691-.599.734-.595 1.216-1.029 1.216-1.627a1.934 1.934 0 00-3.867.001h-2C8.066 7.765 9.831 6 12 6s3.934 1.765 3.934 3.934c0 1.597-1.179 2.55-1.958 3.181z" />
            </svg>

            <span className="text-[#1A1A1A] text-sm font-bold">FAQ</span>
          </Button> */}
          <Button
            className="flex items-center"
            variant="outline"
            href="https://tappi.app/faqs/"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="fill-primary-50 thryve:fill-secondary-50 border border-[#C3B4DA] thryve:border-secondary-50  h-6 w-6 p-1 rounded-full mr-2"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path d="M8.00065 14.6668C4.31865 14.6668 1.33398 11.6822 1.33398 8.00016C1.33398 4.31816 4.31865 1.3335 8.00065 1.3335C11.6827 1.3335 14.6673 4.31816 14.6673 8.00016C14.6673 11.6822 11.6827 14.6668 8.00065 14.6668ZM7.33398 10.0002V11.3335H8.66732V10.0002H7.33398ZM8.66732 8.9035C9.2031 8.74201 9.66306 8.39346 9.96342 7.92132C10.2638 7.44918 10.3846 6.88487 10.3038 6.33114C10.223 5.77742 9.94606 5.27112 9.52333 4.90447C9.1006 4.53781 8.56023 4.33519 8.00065 4.3335C7.46122 4.33346 6.93843 4.52027 6.52118 4.86216C6.10393 5.20405 5.81799 5.67992 5.71198 6.20883L7.01998 6.47083C7.0571 6.28512 7.1462 6.11376 7.2769 5.97671C7.40759 5.83965 7.57453 5.74253 7.75827 5.69663C7.94201 5.65074 8.135 5.65797 8.3148 5.71748C8.49459 5.77698 8.65379 5.88632 8.77387 6.03277C8.89395 6.17922 8.96998 6.35676 8.99311 6.54472C9.01623 6.73269 8.9855 6.92336 8.9045 7.09455C8.82349 7.26574 8.69554 7.4104 8.53553 7.51172C8.37553 7.61303 8.19004 7.66682 8.00065 7.66683C7.82384 7.66683 7.65427 7.73707 7.52925 7.86209C7.40422 7.98712 7.33398 8.15669 7.33398 8.3335V9.3335H8.66732V8.9035Z" />
            </svg>

            <span className="text-[#1A1A1A] text-sm font-bold">FAQS</span>
          </Button>
          <Button
            className="flex items-center"
            variant="outline"
            href="https://tappi.app/terms"
          >
            <svg
              viewBox="0 0 12 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="fill-primary-50 thryve:fill-secondary-50 border border-[#C3B4DA] thryve:border-secondary-50  h-6 w-6 p-1 rounded-full mr-2"
            >
              <path d="M5.99935 4.3335V0.333496H1.99935C1.64573 0.333496 1.30659 0.473972 1.05654 0.72402C0.806491 0.974069 0.666016 1.31321 0.666016 1.66683V12.3335C0.666016 12.6871 0.806491 13.0263 1.05654 13.2763C1.30659 13.5264 1.64573 13.6668 1.99935 13.6668H9.99935C10.353 13.6668 10.6921 13.5264 10.9422 13.2763C11.1922 13.0263 11.3327 12.6871 11.3327 12.3335V5.66683H7.33268C6.97906 5.66683 6.63992 5.52635 6.38987 5.27631C6.13983 5.02626 5.99935 4.68712 5.99935 4.3335ZM2.66602 7.16683C2.66602 7.03422 2.71869 6.90704 2.81246 6.81328C2.90623 6.71951 3.03341 6.66683 3.16602 6.66683C3.29862 6.66683 3.4258 6.71951 3.51957 6.81328C3.61334 6.90704 3.66602 7.03422 3.66602 7.16683C3.66602 7.29944 3.61334 7.42661 3.51957 7.52038C3.4258 7.61415 3.29862 7.66683 3.16602 7.66683C3.03341 7.66683 2.90623 7.61415 2.81246 7.52038C2.71869 7.42661 2.66602 7.29944 2.66602 7.16683ZM2.66602 9.16683C2.66602 9.03422 2.71869 8.90704 2.81246 8.81328C2.90623 8.71951 3.03341 8.66683 3.16602 8.66683C3.29862 8.66683 3.4258 8.71951 3.51957 8.81328C3.61334 8.90704 3.66602 9.03422 3.66602 9.16683C3.66602 9.29944 3.61334 9.42661 3.51957 9.52038C3.4258 9.61415 3.29862 9.66683 3.16602 9.66683C3.03341 9.66683 2.90623 9.61415 2.81246 9.52038C2.71869 9.42661 2.66602 9.29944 2.66602 9.16683ZM2.66602 11.1668C2.66602 11.0342 2.71869 10.907 2.81246 10.8133C2.90623 10.7195 3.03341 10.6668 3.16602 10.6668C3.29862 10.6668 3.4258 10.7195 3.51957 10.8133C3.61334 10.907 3.66602 11.0342 3.66602 11.1668C3.66602 11.2994 3.61334 11.4266 3.51957 11.5204C3.4258 11.6142 3.29862 11.6668 3.16602 11.6668C3.03341 11.6668 2.90623 11.6142 2.81246 11.5204C2.71869 11.4266 2.66602 11.2994 2.66602 11.1668ZM4.66602 7.16683C4.66602 7.03422 4.71869 6.90704 4.81246 6.81328C4.90623 6.71951 5.03341 6.66683 5.16602 6.66683H8.83268C8.96529 6.66683 9.09247 6.71951 9.18624 6.81328C9.28 6.90704 9.33268 7.03422 9.33268 7.16683C9.33268 7.29944 9.28 7.42661 9.18624 7.52038C9.09247 7.61415 8.96529 7.66683 8.83268 7.66683H5.16602C5.03341 7.66683 4.90623 7.61415 4.81246 7.52038C4.71869 7.42661 4.66602 7.29944 4.66602 7.16683ZM4.66602 9.16683C4.66602 9.03422 4.71869 8.90704 4.81246 8.81328C4.90623 8.71951 5.03341 8.66683 5.16602 8.66683H8.83268C8.96529 8.66683 9.09247 8.71951 9.18624 8.81328C9.28 8.90704 9.33268 9.03422 9.33268 9.16683C9.33268 9.29944 9.28 9.42661 9.18624 9.52038C9.09247 9.61415 8.96529 9.66683 8.83268 9.66683H5.16602C5.03341 9.66683 4.90623 9.61415 4.81246 9.52038C4.71869 9.42661 4.66602 9.29944 4.66602 9.16683ZM4.66602 11.1668C4.66602 11.0342 4.71869 10.907 4.81246 10.8133C4.90623 10.7195 5.03341 10.6668 5.16602 10.6668H8.83268C8.96529 10.6668 9.09247 10.7195 9.18624 10.8133C9.28 10.907 9.33268 11.0342 9.33268 11.1668C9.33268 11.2994 9.28 11.4266 9.18624 11.5204C9.09247 11.6142 8.96529 11.6668 8.83268 11.6668H5.16602C5.03341 11.6668 4.90623 11.6142 4.81246 11.5204C4.71869 11.4266 4.66602 11.2994 4.66602 11.1668ZM6.99935 4.3335V0.666829L10.9993 4.66683H7.33268C7.24428 4.66683 7.15949 4.63171 7.09698 4.5692C7.03447 4.50669 6.99935 4.4219 6.99935 4.3335Z" />
            </svg>

            <span className="text-[#1A1A1A] text-sm font-bold">
              Terms & Conditions
            </span>
          </Button>
          <Button
            className="flex items-center"
            variant="outline"
            href="https://tappi.app/privacy-policy"
          >
            <svg
              viewBox="0 0 12 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="fill-primary-50 thryve:fill-secondary-50 border border-[#C3B4DA] thryve:border-secondary-50  h-6 w-6 p-1 rounded-full mr-2"
            >
              <path d="M6.00039 6.6801C5.52039 6.6801 5.20039 7.0001 5.20039 7.4801C5.20039 7.8001 5.44039 8.0401 5.68039 8.1201L5.44039 9.2401H6.48039L6.24039 8.1201C6.56039 8.0401 6.72039 7.8001 6.72039 7.4801C6.80039 7.0001 6.48039 6.6801 6.00039 6.6801ZM6.08039 3.2401C5.52039 3.2401 4.96039 3.6401 4.96039 4.2001V5.4001H7.12039V4.2001C7.04039 3.6401 6.64039 3.2401 6.08039 3.2401ZM6.00039 0.600098L0.400391 3.0001V5.4001C0.480391 8.9201 2.72039 12.0401 6.00039 13.3201C9.28039 12.0401 11.5204 8.9201 11.6004 5.4001V3.0001L6.00039 0.600098ZM9.20039 9.4001C9.20039 9.8801 8.88039 10.2001 8.40039 10.2001H3.60039C3.12039 10.2001 2.80039 9.8801 2.80039 9.4001V6.2001C2.80039 5.7201 3.12039 5.4001 3.60039 5.4001H3.84039V4.2001C3.92039 3.0801 4.88039 2.2001 6.00039 2.2001C7.12039 2.2001 8.08039 3.0801 8.16039 4.2001V5.4001H8.40039C8.88039 5.4001 9.20039 5.7201 9.20039 6.2001V9.4001Z" />
            </svg>

            <span className="text-[#1A1A1A] text-sm font-bold">
              Privacy Policy
            </span>
          </Button>
          <Button
            className="flex items-center justify-between"
            variant="outline"
            href={`https://wa.me/${tappiWhatsappNumber}`}
          >
            <span className="text-[#1A1A1A] text-sm font-bold">Need Help?</span>
            <div className="flex bg-primary-50 tappi:text-white rounded-xl p-2 px-4 h-9">
              <img
                className="h-4 w-4 mr-2"
                src={WhatsAppIcon}
                alt="Reach Us On WhatsApp"
              />
              <span className="text-sm font-bold">Chat With Us</span>
            </div>
          </Button>
          <button
            onClick={() => showDialogueHandler(true, "Invite friends to Tappi")}
            type="button"
            className="border border-solid rounded-xl p-4 bg-primary-50 tappi:text-white flex flex-col"
          >
            <span className="font-bold text-sm">Invite Friends</span>
            <span className="text-left text-sm font-normal">
              Grow together by sharing Tappi with your circle.
            </span>
            <span className="text-left text-sm text-sm font-normal underline">
              Get Started
            </span>
          </button>

          <Button
            className="flex items-center"
            variant="outline"
            onClick={handleLogout}
          >
            <svg
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              className="border border-[#ED1D24] h-6 w-6 p-1 rounded-full mr-2"
            >
              <path
                d="M7.99979 0.888916C6.59334 0.888916 5.21848 1.30598 4.04906 2.08735C2.87965 2.86873 1.9682 3.97934 1.42998 5.27872C0.891753 6.57811 0.750929 8.00792 1.02531 9.38734C1.2997 10.7668 1.97696 12.0338 2.97147 13.0283C3.96598 14.0228 5.23306 14.7001 6.61248 14.9745C7.9919 15.2489 9.42171 15.1081 10.7211 14.5698C12.0205 14.0316 13.1311 13.1202 13.9125 11.9507C14.6938 10.7813 15.1109 9.40647 15.1109 8.00003C15.1109 6.11404 14.3617 4.3053 13.0281 2.97171C11.6945 1.63812 9.88577 0.888916 7.99979 0.888916ZM8.02645 8.74669C7.95137 8.74728 7.87692 8.733 7.80738 8.70467C7.73785 8.67635 7.67461 8.63453 7.62131 8.58165C7.56801 8.52877 7.52571 8.46585 7.49684 8.39654C7.46798 8.32723 7.45312 8.25289 7.45312 8.1778V3.84447C7.45312 3.69241 7.51352 3.54658 7.62105 3.43906C7.72857 3.33154 7.8744 3.27114 8.02645 3.27114C8.17851 3.27114 8.32434 3.33154 8.43186 3.43906C8.53938 3.54658 8.59979 3.69241 8.59979 3.84447V8.1778C8.59979 8.25289 8.58493 8.32723 8.55606 8.39654C8.52719 8.46585 8.48489 8.52877 8.43159 8.58165C8.3783 8.63453 8.31506 8.67635 8.24552 8.70467C8.17599 8.733 8.10153 8.74728 8.02645 8.74669ZM7.99979 12.3511C7.0637 12.3622 6.14857 12.0738 5.38795 11.5281C4.62733 10.9823 4.06104 10.2078 3.77171 9.31746C3.48238 8.42714 3.48516 7.46765 3.77964 6.57902C4.07413 5.69039 4.64491 4.91914 5.40868 4.3778C5.54171 4.28298 5.70669 4.24428 5.86801 4.27006C6.02933 4.29584 6.17404 4.38403 6.2709 4.51558C6.31818 4.58055 6.35214 4.65423 6.37081 4.73239C6.38948 4.81054 6.3925 4.89161 6.3797 4.97094C6.36689 5.05026 6.33851 5.12627 6.29619 5.19457C6.25387 5.26288 6.19845 5.32213 6.13312 5.36892C5.6938 5.69155 5.34445 6.12134 5.11836 6.6173C4.89228 7.11326 4.797 7.65886 4.84161 8.2021C4.88622 8.74533 5.06923 9.26808 5.37319 9.72052C5.67715 10.173 6.09194 10.54 6.578 10.7866C7.06406 11.0333 7.6052 11.1513 8.14983 11.1295C8.69445 11.1077 9.22441 10.9467 9.68917 10.6619C10.1539 10.3772 10.538 9.9781 10.8048 9.50279C11.0716 9.02748 11.2121 8.49175 11.2131 7.94669C11.2116 7.44449 11.0898 6.94995 10.8578 6.50454C10.6258 6.05912 10.2904 5.6758 9.87979 5.38669C9.75334 5.2869 9.67159 5.14108 9.65243 4.98114C9.63327 4.8212 9.67826 4.66019 9.77756 4.53336C9.87574 4.4032 10.0211 4.31677 10.1823 4.29267C10.3436 4.26857 10.5078 4.30871 10.6398 4.40447C11.3956 4.952 11.9573 5.7261 12.2433 6.61445C12.5294 7.5028 12.525 8.4592 12.2308 9.34489C11.9366 10.2306 11.3678 10.9995 10.607 11.54C9.8462 12.0806 8.93297 12.3647 7.99979 12.3511Z"
                fill="#ED1D24"
              />
            </svg>

            <span className="text-[#1A1A1A] text-sm font-bold">Log Out</span>
          </Button>

          <p className="text-base font-semibold pt-8 px-2">Dangerous Area</p>

          <div className="flex flex-col my-4">
            <Button
              className="flex items-center"
              variant="outline"
              href="/account/delete"
            >
              <svg
                viewBox="0 0 24 24"
                className="border border-[#ED1D24] h-6 w-6 p-1 rounded-full mr-2"
                height="1em"
                width="1em"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                  fill="#ED1D24"
                  d="M7 4V2h10v2h5v2h-2v15a1 1 0 01-1 1H5a1 1 0 01-1-1V6H2V4h5zM6 6v14h12V6H6zm3 3h2v8H9V9zm4 0h2v8h-2V9z"
                />
              </svg>

              <span className="text-[#1A1A1A] text-sm font-semibold">
                Delete Account
              </span>
            </Button>
            <p className="text-[#56637099] mt-2 px-2 text-sm">
              If you delete your account now, you will have the option to
              recover it within 30 days.
            </p>
          </div>
        </div>
        <div className="pt-12 text-black mx-auto flex flex-col items-center justify-center">
          <p className="italic text-sm">Powered by</p>
          <a href="https://tappi.app" target="_blank" rel="noreferrer">
            <svg
              width="41"
              height="18"
              viewBox="0 0 41 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_7616_11288)">
                <path
                  d="M6.40804 10.8399L6.88821 13.1074C6.83296 13.1626 6.75289 13.2287 6.64799 13.3061C6.54309 13.3835 6.29193 13.4853 5.8945 13.6123C5.49707 13.7393 5.05534 13.8028 4.56956 13.8028C3.76349 13.8028 3.07886 13.5214 2.51568 12.9585C1.95277 12.3957 1.67118 11.7115 1.67118 10.906V6.85109H0.511719V4.53369H1.67118V2.21655H3.98983V4.53369H6.54043V6.85109H3.98983V10.0951C3.98983 10.4371 4.08645 10.7049 4.27969 10.8977C4.47294 11.0911 4.66324 11.1986 4.85115 11.2208L5.14929 11.2536C5.42527 11.2536 5.66816 11.2208 5.87795 11.1543C6.08775 11.0882 6.23134 11.022 6.30848 10.9559L6.40804 10.8399ZM13.9272 4.99727L14.2915 4.53369H16.2461V13.8028H13.9272V13.1738C13.2094 13.5931 12.4365 13.8028 11.6085 13.8028C10.3276 13.8028 9.23462 13.3504 8.32899 12.4453C7.42363 11.5406 6.97095 10.4483 6.97095 9.16822C6.97095 7.88816 7.42363 6.79587 8.32899 5.89111C9.23462 4.98607 10.3276 4.53369 11.6085 4.53369C12.4365 4.53369 13.2094 4.74334 13.9272 5.16265V4.99727ZM9.96889 10.8068C10.4216 11.2592 10.9682 11.4854 11.6085 11.4854C12.2488 11.4854 12.7955 11.2592 13.2482 10.8068C13.7008 10.3544 13.9272 9.80812 13.9272 9.16822C13.9272 8.52832 13.7008 7.98205 13.2482 7.52966C12.7955 7.07728 12.2488 6.85109 11.6085 6.85109C10.9682 6.85109 10.4216 7.07728 9.96889 7.52966C9.51594 7.98205 9.28987 8.52832 9.28987 9.16822C9.28987 9.80812 9.51594 10.3544 9.96889 10.8068ZM21.9601 4.53369C23.2407 4.53369 24.334 4.98607 25.2394 5.89111C26.1447 6.79587 26.5974 7.88816 26.5974 9.16822C26.5974 10.4483 26.1447 11.5406 25.2394 12.4453C24.334 13.3504 23.2407 13.8028 21.9601 13.8028C21.1319 13.8028 20.3589 13.5931 19.6412 13.1738V17.2786H17.3225V4.53369H19.2769L19.6412 4.99727V5.16265C20.3589 4.74334 21.1319 4.53369 21.9601 4.53369ZM20.3202 10.8068C20.7729 11.2592 21.3195 11.4854 21.9601 11.4854C22.6004 11.4854 23.1471 11.2592 23.5997 10.8068C24.0524 10.3544 24.2788 9.80812 24.2788 9.16822C24.2788 8.52832 24.0524 7.98205 23.5997 7.52966C23.1471 7.07728 22.6004 6.85109 21.9601 6.85109C21.3195 6.85109 20.7729 7.07728 20.3202 7.52966C19.8675 7.98205 19.6412 8.52832 19.6412 9.16822C19.6412 9.80812 19.8675 10.3544 20.3202 10.8068ZM31.8975 4.53369C33.1781 4.53369 34.2714 4.98607 35.1767 5.89111C36.0821 6.79587 36.5348 7.88816 36.5348 9.16822C36.5348 10.4483 36.0821 11.5406 35.1767 12.4453C34.2714 13.3504 33.1781 13.8028 31.8975 13.8028C31.0692 13.8028 30.2965 13.5931 29.5788 13.1738V17.2786H27.2599V4.53369H29.2142L29.5788 4.99727V5.16265C30.2965 4.74334 31.0692 4.53369 31.8975 4.53369ZM30.2578 10.8068C30.7105 11.2592 31.2569 11.4854 31.8975 11.4854C32.5378 11.4854 33.0844 11.2592 33.5371 10.8068C33.9898 10.3544 34.2161 9.80812 34.2161 9.16822C34.2161 8.52832 33.9898 7.98205 33.5371 7.52966C33.0844 7.07728 32.5378 6.85109 31.8975 6.85109C31.2569 6.85109 30.7105 7.07728 30.2578 7.52966C29.8049 7.98205 29.5788 8.52832 29.5788 9.16822C29.5788 9.80812 29.8049 10.3544 30.2578 10.8068ZM39.5658 13.8028H37.2471V4.53369H39.5658V13.8028Z"
                  fill="#4B1D8F"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M38.5294 0C39.624 0 40.5112 0.88663 40.5112 1.98051C40.5112 3.0744 39.624 3.96103 38.5294 3.96103C37.4351 3.96103 36.5479 3.0744 36.5479 1.98051C36.5479 0.88663 37.4351 0 38.5294 0Z"
                  fill="url(#paint0_linear_7616_11288)"
                />
                <path
                  d="M37.6388 1.74495L38.1633 2.34137L39.6211 1.00049L39.9681 1.37739L38.1248 3.07249L37.2539 2.08184L37.6388 1.74495Z"
                  fill="white"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_7616_11288"
                  x1="36.5479"
                  y1="1.98051"
                  x2="40.5112"
                  y2="1.98051"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FFAD03" />
                  <stop offset="0.65098" stopColor="#FE8005" />
                  <stop offset="1" stopColor="#FD5308" />
                </linearGradient>
                <clipPath id="clip0_7616_11288">
                  <rect
                    width="40"
                    height="17.2786"
                    fill="white"
                    transform="translate(0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
          </a>
        </div>
      </div>
    </Layout>
  );
}
